import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import CardOverview from '@/root/components/CardOverview';
import {ROUTES} from '@/root/constants/routes';
import {useCardGroup} from '@/root/queries/cards';
import {useEmblaStore} from '@/root/stores/cardCarousel';

import Halfview from '@/shared/components/Halfview';
import {TIARA_DETAIL_ACTION, TIARA_DETAIL_PAGE_NAME} from '@/shared/constants/tiara';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';
import useTiara from '@/shared/hooks/useTiara';
import {useHalfviewStore} from '@/shared/stores/halfview';

const CardListHalfview = () => {
  const {trackEvent} = useTiara({pageName: TIARA_DETAIL_PAGE_NAME.CARD_LIST});
  const {groupCode = ''} = useParams<{groupCode: string}>();
  const {classnames, setClassnames, closeHalfview} = useHalfviewStore();
  const navigate = useAdvancedNavigate();
  const {
    data: {cards}
  } = useCardGroup(groupCode);

  const emblaApi = useEmblaStore((state) => state.emblaApi);

  const onExited = () => {
    navigate(ROUTES.CARD_GROUP, {pathParams: {groupCode}});
  };

  const onSelectCard = (index: number) => () => {
    const cardName = cards[index].overview.title;
    emblaApi?.scrollTo(index);
    closeHalfview();
    trackEvent({
      action: TIARA_DETAIL_ACTION.CARD_LIST_CARD_CLICK,
      customProps: {card_name: cardName, group_code: groupCode}
    });
  };

  useHistoryBackAOS(() => {
    closeHalfview();
  }, []);

  useEffect(() => {
    setClassnames('modal_list');
    if (!emblaApi) return;
    const selectedIndex = emblaApi.selectedScrollSnap();
    const cardName = cards[selectedIndex].overview.title;
    trackEvent({
      action: TIARA_DETAIL_ACTION.CARD_LIST_VIEW,
      customProps: {group_code: groupCode, card_name: cardName}
    });
  }, []);

  return (
    <Halfview.Wrapper classnames={classnames} onExited={onExited}>
      <Halfview.Header>
        <Halfview.Title headingLevel="h3">카드 목록</Halfview.Title>
      </Halfview.Header>
      <Halfview.Body>
        <div className="inner_g">
          <span className="txt_count" role="text">
            전체 <em className="emph_g">{cards.length}</em> <span className="screen_out">개</span>
          </span>
          <div className="group_list">
            {cards.map((card, index) => (
              <CardOverview key={card.cardId} card={card} onClick={onSelectCard(index)} />
            ))}
          </div>
        </div>
      </Halfview.Body>
    </Halfview.Wrapper>
  );
};

export default CardListHalfview;
